import * as api from "./exercise.api";
import * as mocks from "./exercise.mocks";
import config from "../../config/config";
import {
  EvaluateExerciseResponse,
  ExerciseItem,
  VerifyExerciseRequest,
  VerifyExerciseResponse,
} from "./exercise.interfaces";
import { recordUserBehaviorEvent } from "@/services/analytics/userBehaviorEvents.api";

/**
 * Busca exercícios para um módulo específico.
 * Alterna entre implementação real e mock baseado na configuração.
 */
export const fetchExercisesByModule = async (moduleId: string): Promise<ExerciseItem[]> => {
  try {
    if (config.useRealApi) {
      const result = await api.apiFetchExercisesByModule(moduleId);
      console.log("Exercise data from API:", result);
      return result;
    } else {
      const result = await mocks.fetchExercisesByModule();
      console.log("Exercise data from mocks:", result);
      return result;
    }
  } catch (error) {
    console.error("Error in fetchExercisesByModule:", error);
    // Em caso de erro, podemos retornar os mocks como fallback
    return mocks.fetchExercisesByModule();
  }
};

/**
 * Avalia a resposta de um exercício no servidor
 * @param data Os dados do exercício e a resposta do aluno
 * @returns Um objeto com o resultado da avaliação
 */
export const evaluateExerciseAnswer = async (
  data: VerifyExerciseRequest
): Promise<EvaluateExerciseResponse> => {
  try {
    const result = config.useRealApi
      ? await api.apiEvaluateExerciseAnswer(data)
      : await mocks.mockEvaluateExerciseAnswer(data);
    recordUserBehaviorEvent("ExerciseAnswered", {
      exerciseType: data.exerciseType,
      moduleId: data.moduleId,
      isCorrect: String(result.isCorrect),
    });
    return result;
  } catch (error) {
    console.error("Erro ao avaliar exercício:", error);
    throw error;
  }
};

/**
 * Verifica a resposta de um exercício (alias para evaluateExerciseAnswer)
 * @param data Os dados do exercício e a resposta do aluno
 * @returns Um objeto com o resultado da avaliação
 */
export const verifyExerciseAnswer = async (
  data: VerifyExerciseRequest
): Promise<EvaluateExerciseResponse> => {
  return evaluateExerciseAnswer(data);
};

/**
 * Avalia a resposta sem registrar progresso/duplicatas (para teste de módulo).
 */
export const evaluateExerciseAnswerOnly = async (
  data: VerifyExerciseRequest
): Promise<VerifyExerciseResponse> => {
  return api.apiEvaluateExerciseAnswerOnly(data);
};